
<div class="dashboard-content-sec ">
    <div class="loader" *ngIf="showloader">
        <img src="assets/images/loader.gif" alt="">
    </div>

    <form (ngSubmit)="saveDocument(editForm)" [formGroup]="form" #editForm="ngForm">
        <div class="row form-section">
            <div class="col">
                <div class="card mb-0">
                    <app-breadcrumb [crumbList] = "crumbList"></app-breadcrumb>
                    <div class="card-title">
                        <h5 class="fa fa-building">
                          {{ this.title }}
                        </h5>

                        <div class="float-right">
                            <button type="submit" class="btn btn-default align-items-end" tabindex="100">Save</button>
                        </div>
                    </div>

                    <div class="card-form" class="collapse show">

                        <div *ngIf="submitted && this.form.invalid" class="invalid-feedback">
                            <span >Please review for the form for invalid fields</span>
                        </div>

                        <div *ngIf="this.successful_result"
                            class="alert alert-success" role="alert">
                            Successfully saved record
                        </div>
                        <div *ngIf="this.error_result" class="alert alert-danger" role="alert">
                            Unable to save record. Error occurred.
                        </div>

                        <div class="form-row" >
                            <label class='col-sm-2'>Name</label>
                            <div class='form-group col-sm-4'>
                                <input type="text" class="form-control"
                                       formControlName="Name" name="Name">

                                <div *ngIf="NameCtrl.invalid && (NameCtrl.dirty || NameCtrl.touched)"
                                    class="invalid-feedback">
                                    <div>
                                        <span>Name is required.</span>
                                    </div>
                                </div>        
                            </div>
                        </div>

                        <div class="form-row" >
                            <label class='col-sm-2'>URL for Doc</label>
                            <div class='form-group col-sm-4'>
                                <input class="form-control" formControlName="Link" name="Link">

                                <div *ngIf="LinkCtrl.invalid && (LinkCtrl.dirty || LinkCtrl.touched) && !LinkCtrl.errors.pattern"
                                    class="invalid-feedback">
                                    <div>
                                        <span>URL is required.</span>
                                    </div>
                                </div>        
                                <div *ngIf="LinkCtrl.errors && LinkCtrl.errors.pattern" class="invalid-feedback">
                                    <span>Invalid URL format</span>
                                </div>             
                            </div>
                        </div>

                        <div class="form-row">
                            <label class='col-sm-2'>Category</label>
                            <div class='col-sm-2 mb-3'>
                                <select id="category" class="custom-select"> 
                                    <option value="{{page.ID}}"
                                        [selected]="page.Name == category"
                                        *ngFor="let page of pages">{{page?.Name}}
                                    </option>
                                </select>      
                            </div>
                        </div>                        

                        <div class="form-row" >
                            <label class='col-sm-2'>Author</label>
                            <div class='form-group col-sm-4'>
                                <input type="text" class="form-control"
                                       formControlName="LastAuthor" name="LastAuthor">
                            </div>
                        </div>

                        <div class="form-row" >
                            <label class='col-sm-2'>Revision Date</label>
                            <div class='col-sm-2 mb-3'>
                                <div class="input-group">
                                    <input class="form-control" placeholder="yyyy-mm-dd"
                                        name="RevisionDate" id="RevisionDate" 
                                        formControlName="RevisionDate"
                                        data-container="body"
                                        ngbDatepicker #d="ngbDatepicker"
                                        style="width: 200px ">
                                    <div class="input-group-append">
                                        <button class="btn btn-outline-secondary calendar fa fa-calendar" 
                                            (click)="d.toggle()" type="button"></button>
                                    </div>
                                </div>
                                <div *ngIf="RevisionDateCtrl.invalid && (RevisionDateCtrl.dirty || RevisionDateCtrl.touched)"
                                    class="invalid-feedback">
                                    <div>
                                        <span>Date is required.</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                          
                        <div class="form-row" >
                            <label class='col-sm-2'>Revision #</label>
                            <div class='form-group col-sm-2'>
                                <input type="number" class="form-control"
                                       formControlName="Revision" name="Revision">

                                <div *ngIf="RevisionCtrl.invalid && (RevisionCtrl.dirty || RevisionCtrl.touched)"
                                    class="invalid-feedback">
                                    <div>
                                        <span>Revision is required.</span>
                                    </div>
                                </div>        
                            </div>
                        </div>

                        <div class="form-row">
                            <label class="col-sm-2 control-label">State Specific</label>
                            <div class="form-group col-sm-4">
                                <label class="switch">
                                    <input type="checkbox" (change)="toggleChange($event,'State')" [checked]="hasState == 'Yes'" >
                                    <span class="slider"></span>
                                </label>
                                <label class="col-sm-3" id="hasStateLabel">{{hasState}}</label> 
                            </div>
                        </div>

                        <div class="form-row" *ngIf='hasState === "Yes"'>
                            <label class='col-sm-2'>State</label>
                            <div class='col-sm-2 mb-3'>
                                <select id="state" class="custom-select" style="width: 100px"> 
                                    <option value="{{st.ID}}"
                                        [selected]="st.Code == state"
                                        *ngFor="let st of states">{{st?.Code}}                                                                
                                    </option>
                                </select>      
                            </div>
                        </div>


                        <div class="form-row">
                            <label class="col-sm-2 control-label">Contains Date(s)</label>
                            <div class="form-group col-sm-4">
                                <label class="switch">
                                    <input type="checkbox" (change)="toggleChange($event,'Date')" [checked]="hasDate == 'Yes'" >
                                    <span class="slider"></span>
                                </label>
                                <label class="col-sm-3">{{hasDate}}</label> 
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </form>

</div>


